// report.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { saveAs } from "file-saver";

export function gerarPdfRecibo({
	numeroComprovante,
	dataHora,
	dataHoraVencimento,
	estabelecimento,
	titular,
	metodo,
	valor,
	itens = [],
}) {
	const doc = new jsPDF("p", "mm", "a4");
	const pageWidth = doc.internal.pageSize.getWidth();
	const margin = 14;

	// =========================
	// FAIXA SUPERIOR (VERDE)
	// =========================
	const headerHeight = 28;

	doc.setFillColor(5, 150, 105); // verde tipo tailwind emerald-600
	doc.rect(0, 0, pageWidth, headerHeight, "F");

	// =========================
	// CÍRCULO + CHECK DESENHADO
	// =========================
	const circleX = margin + 5;
	const circleY = headerHeight / 2;

	// círculo verde claro
	doc.setFillColor(16, 185, 129);
	doc.circle(circleX, circleY, 5, "F");

	// check com duas linhas brancas
	doc.setDrawColor(255, 255, 255);
	doc.setLineWidth(1.2);
	// deixa as pontas arredondadas
	if (doc.setLineCap) {
		doc.setLineCap("round");
	}

	// coordenadas relativas pro "V"
	// perna esquerda
	doc.line(circleX - 2.5, circleY, circleX - 0.5, circleY + 2.5);
	// perna direita
	doc.line(circleX - 0.5, circleY + 2.5, circleX + 3, circleY - 1);

	// =========================
	// TEXTO "Pagamento / Aprovado"
	// =========================
	doc.setTextColor(255, 255, 255);
	const leftTextX = circleX + 9;

	doc.setFont("helvetica", "normal");
	doc.setFontSize(8);
	doc.text("Pagamento", leftTextX, 11);

	doc.setFont("helvetica", "bold");
	doc.setFontSize(14);
	doc.text("Aprovado", leftTextX, 19);

	// comprovante + data à direita
	const rightX = pageWidth - margin;
	doc.setFont("helvetica", "normal");
	doc.setFontSize(9);
	doc.text(`Comprovante #${numeroComprovante}`, rightX, 11, { align: "right" });
	doc.text(`Data Vencimento: ${dataHoraVencimento}`, rightX, 18, { align: "right" });
	doc.text(`Data Pagamento: ${dataHora}`, rightX, 25, { align: "right" });

	// =========================
	// BLOCO DE DADOS (2 COLUNAS)
	// =========================
	let y = headerHeight + 10;
	const xLeft = margin;
	const xRight = pageWidth / 2 + 5;

	// labels em cinza
	doc.setTextColor(107, 114, 128);
	doc.setFontSize(9);
	doc.setFont("helvetica", "normal");

	// linha 1: Estabelecimento | Método
	doc.text("Estabelecimento", xLeft, y);
	doc.text("Método", xRight, y);
	y += 5;

	// valores em negrito
	doc.setFont("helvetica", "bold");
	doc.setTextColor(31, 41, 55);
	doc.text(String(estabelecimento || "—"), xLeft, y);
	doc.text(String(metodo || "—"), xRight, y);
	y += 8;

	// linha 2: Titular | Valor
	doc.setFont("helvetica", "normal");
	doc.setTextColor(107, 114, 128);
	doc.text("Titular", xLeft, y);
	doc.text("Valor", xRight, y);
	y += 5;

	// valores em negrito (valor verde)
	doc.setFont("helvetica", "bold");
	doc.setTextColor(31, 41, 55);
	doc.text(String(titular || "—"), xLeft, y);

	doc.setTextColor(5, 150, 105);
	doc.text(String(valor || "—"), xRight, y);
	y += 10;

	// volta padrão
	doc.setTextColor(31, 41, 55);
	doc.setFont("helvetica", "normal");

	// =========================
	// RESUMO DO PEDIDO (TABELA)
	// =========================
	if (itens.length > 0) {
		doc.setFontSize(11);
		doc.text("Resumo do pedido", margin, y);
		y += 4;

		const body = itens.map((it, idx) => [
			idx + 1,
			it.nome,
			it.qtd,
			it.total, // já vem formatado
		]);

		autoTable(doc, {
			startY: y + 2,
			head: [["#", "Descrição", "Qtd", "Total"]],
			body,
			styles: {
				fontSize: 9,
				cellPadding: 2,
			},
			headStyles: {
				fillColor: [243, 244, 246],
				textColor: 0,
			},
			theme: "grid",
			margin: { left: margin, right: margin },
			tableWidth: "auto",
		});

		const finalY = doc.lastAutoTable.finalY || y + 10;

		doc.setFontSize(11);
		doc.setFont("helvetica", "bold");
		doc.setTextColor(31, 41, 55);
		doc.text("Total:", pageWidth - margin - 30, finalY + 8);
		doc.setTextColor(5, 150, 105);
		doc.text(String(valor || "—"), pageWidth - margin, finalY + 8, {
			align: "right",
		});
	}

	// =========================
	// RODAPÉ
	// =========================
	const footerY = doc.internal.pageSize.getHeight() - 15;
	doc.setFontSize(8);
	doc.setTextColor(148, 163, 184);
	doc.setFont("helvetica", "normal");
	doc.text("Este comprovante é uma via digital do pagamento realizado.", margin, footerY);

	const blob = doc.output("blob");
	saveAs(blob, `recibo-${numeroComprovante}.pdf`);
}
